import { createCapHeader, createMeta } from "../../../components/hocs/createCapHeader";
import { historyGoBack } from "../../../utils/page";

const title = "Notifications";
export const CapNotificationsHeader = createCapHeader(title, historyGoBack);
export const NotificationsMeta = createMeta(title);
